import { memo } from "react";

const SingleItem = ({ title, content, textStyle }: { title: string, content: any, textStyle: string }) => {
	return <div className='table-mobile__item__wrap' key={title}>
		<p className='table-mobile__item__title'>{title}</p>
		{typeof (content) != 'object' ? <p className={textStyle}>{content}</p> : content}
	</div>
}
export default memo(SingleItem)